// import React from 'react';
// import { __, Event, isMobile, isTablet, playAudio } from 'utils/Helper';
// import C from 'utils/Constant';
// import Canvas from "./Canvas";
// import storage from "utils/Storage";
// import {  wait, isValidNumber, forceSatoshiFormat, sendNotfication,} from 'utils/Helper';

// class  Game extends React.Component {
//     _isMounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             engine: this.props.engine,
//             canvas: null,
//             interval: [],

//             bet: 'manual',
//             buttonText: 'Roll',
//             started: false,
//             isLogged: storage.getKey("logged") !== null ? true : false,
//             amount: forceSatoshiFormat(storage.getKey('lam') ? storage.getKey('lam') : .00000010),
//             disabled: false,
//             payout: '1.0102',
//             type: 'low',
//             betNumber: 10,
//             firstBetNumber: 10,
//             onWin: 0,
//             onLost: 0,
//             stopOnWin: 0
//         };
//         this.handleChange = this.handleChange.bind(this);
//     }

    
//     handleChange(value) {
//         if (this._isMounted) {
//             this.setState({ type: value });
//             Event.emit('change_type', value);
//         }
//     }

//     componentDidMount() {
//         this._isMounted = true;
//         let { engine } = this.state;

//         engine.on(C.PLAY_HASH_DICE, (data) => this.play(data));

//         var canvas = new Canvas(engine);
//         canvas.init();

//         Event.on('change_type', (type) => {
//             canvas.changeLabel(type);
//         })

//         this.setState({ canvas: canvas });

//         if (isMobile() || isTablet()) {
//             let c = document.getElementById('game');
//             c.style.width = '100%'
//             c.style.height = '100%'
//         }
//     }

//     componentWillUnmount() {
//         this._isMounted = false;

//         if (this.state.canvas !== null)
//             this.state.canvas.destroy();
//     }

//     play(data) {
//         if (this._isMounted) {
//             let target = __.toString(data.target)
//             this.state.canvas.play(target);
//             playAudio('dice.mp3');
//         }
//     }

//     render() {
//         let { disabled, amount, bet, type, started, mt } = this.state;
//         return <>
//             {/* <div className="text-center animated fadeIn" style={{height:"110vh",position:"relative"}}>
//             <img src='/assets/images/hashdice-bg1.png' style={{width:"70%",zIndex:"-1",position:"absolute"}}/>
//                 <div id="loading" className="ycenter"
//                  style={{position:"absolute"}}
//                 />
              
//                 <canvas id="game" style={{zIndex:"999",width:"54%",marginLeft:"47px",marginTop:"130px"}}/>
//             </div> */}
//             <div className="hashdice-container" style={{paddingBottom:"80px"}}>
//   <img
//     src='/assets/images/hashdice-bg1.png'
//     className="hashdice-background-img"
//     alt="background"
//   />
//   <div id="loading" className="hashdice-loading" />
  
//   <canvas
//     id="game"
//     className="hashdice-game-canvas"
//   />
// </div>
// <div>
// <div className={" text-center btn-group-toggle mb-3 " + mt} data-toggle="buttons">
//                         <label className={'' + type === 'low' ? 'btn bg-cs2 btn-xs hslb  active' : 'btn bg-cs2 btn-xs hslb '}>
//                             <input disabled={disabled} onClick={e => this.handleChange('low')} type="radio" /> Low
//                         </label>
//                         <label className={'' + type === 'high' ? 'btn bg-cs2 btn-xs hsrb  active' : 'btn bg-cs2 btn-xs hsrb '}>
//                             <input disabled={disabled} onClick={e => this.handleChange('high')} type="radio" /> High
//                         </label>
//                     </div>
// </div>

//         </>;
//     }
// }

// export default Game;



import React from 'react';
import { __, Event, isMobile, isTablet, playAudio } from 'utils/Helper';
import C from 'utils/Constant';
import Canvas from "./Canvas";
import storage from "utils/Storage";
import { wait, isValidNumber, forceSatoshiFormat, sendNotfication } from 'utils/Helper';
import { style } from '@mui/system';

class Game extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: this.props.engine,
            canvas: null,
            interval: [],
            bet: 'manual',
            buttonText: 'Roll',
            started: false,
            isLogged: storage.getKey("logged") !== null ? true : false,
            amount: forceSatoshiFormat(storage.getKey('lam') ? storage.getKey('lam') : .00000010),
            disabled: false,
            payout: '1.0102',
            type: 'low',
            betNumber: 10,
            firstBetNumber: 10,
            onWin: 0,
            onLost: 0,
            stopOnWin: 0,
            dynamicValue: '<50000', // Added dynamic value for display
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {
        if (this._isMounted) {
            this.setState({ 
                type: value, 
                dynamicValue: value === 'low' ? '<50000' : '>49999' // Update dynamic value
            });
            Event.emit('change_type', value);
        }
    }

    componentDidMount() {
        this._isMounted = true;
        let { engine } = this.state;

        engine.on(C.PLAY_HASH_DICE, (data) => this.play(data));

        var canvas = new Canvas(engine);
        canvas.init();

        Event.on('change_type', (type) => {
            canvas.changeLabel(type);
        });

        this.setState({ canvas: canvas });

        if (isMobile() || isTablet()) {
            let c = document.getElementById('game');
            c.style.width = '100%';
            c.style.height = '100%';
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

        if (this.state.canvas !== null)
            this.state.canvas.destroy();
    }

    play(data) {
        if (this._isMounted) {
            let target = __.toString(data.target);
            this.state.canvas.play(target);
            playAudio('dice.mp3');
        }
    }

    render() {
        let { disabled, amount, bet, type, started, mt, dynamicValue } = this.state;
        return (
            <>
                <div className="hashdice-container" style={{ paddingBottom: "80px" }}>
                    <img
                        src='/assets/images/hashdice-bg1.png'
                        className="hashdice-background-img"
                        alt="background"
                    />
                    <div id="loading" className="hashdice-loading" />
                    <canvas
                        id="game"
                        className="hashdice-game-canvas"
                    />
                </div>

                <div  className="game-fonts">
                    <div className={"text-center btn-group-toggle " + mt} data-toggle="buttons" style={{ display: "flex", alignItems: "center", justifyContent: "center" ,width:"100%" }}>
                        <div style={{ display: "flex", alignItems: "center",justifyContent:"center", width: "100%"}}>

                            {/* Low button */}
                            <label className={ type === 'low' ? 'btn bg-cs2 btn-xs hslb active ' : 'btn bg-cs2 btn-xs hslb'} 
                                style={{
                                    justifyContent:"center", 
                                    width: "150px", 
                                    display:"flex",
                                    padding: "10px", 
                                    textAlign: "center", 
                                    backgroundColor: type === 'low' ? '#3c3f48' : '#3c3f48', 
                                    color: type === 'low' ? 'green' : '',  // Set green text when active
                                    border: type === 'low' ? '2px solid green' : ''  // Border green when active
                                }}>
                                <input className='low-btn' disabled={disabled} onClick={e => this.handleChange('low')} type="radio" /> Low
                            </label>

                            {/* Dynamic value placed in the center */}
                            <span className="dynamic-value game-fonts low-btn" style={{ 
                                width: "200px", 
                                padding: "10px", 
                                textAlign: "center", 
                                alignItems:"center",
                                height:"45px",
                              display:"flex",
                              justifyContent:"center",
                                marginTop:"-7px",
                                fontSize:"19px",
                                backgroundColor: "#33373e", 
                                color: "white", 
                                borderRadius: "5px" 
                            }}
                            
                            >
                                {dynamicValue}
                            </span>

                            {/* High button */}
                            <label className={type === 'high' ? 'btn bg-cs2 btn-xs hsrb active' : 'btn bg-cs2 btn-xs hsrb'}
                                style={{ 
                                    width: "150px", 
                                    padding: "10px", 
                                    textAlign: "center", 
                                    backgroundColor: type === 'high' ? '#3c3f48' : '#3c3f48', 
                                    color: type === 'high' ? 'green' : '', // Set green text when active
                                    border: type === 'high' ? '2px solid green' : ''  // Border green when active
                                }}>
                                <input className='low-btn' disabled={disabled} onClick={e => this.handleChange('high')} type="radio" /> High
                            </label>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Game;
